<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-4">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Savings(KES)</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i> 3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
              <hr>
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Number of active Savings</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i>  3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">On Track Savings(KES)</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
                <div class="col-auto">
                  <div class="">
                    <i class="fa fa-users fa-3x"></i>
                  </div>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i> 3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
              <hr>
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Number of on Track</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i>  3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-stats mb-4 mb-xl-0">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Estimated Savings(KES)</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i> 3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
              <hr>
              <div class="row">
                <div class="col">
                  <h6 class="card-title text-uppercase text-muted" style="font-size: 12px">Estimated Number</h6>
                  <span class="h4 font-weight-bold">0</span>
                </div>
              </div>
              <p class="mt-3 mb-0 text-muted text-sm">
                <span class="card_green  mr-2"><i class="icon-arrow-top-right"></i>  3.48%</span>
                <span class="text-nowrap">Compared to last month</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <px-card>
            <div slot="with-padding">
              <div class="row">
                <div class="col-md-2">
                  <h5>Savings Maturity</h5>
                </div>
                <div class="col-md-4">
                  <b-input-group class="border rounded-pill p-1">
                    <div class="input-group-prepend border-0">
                      <button id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button>
                    </div>
                    <b-form-input
                        v-model="searchTitle"
                        placeholder="Type to Search"
                        aria-describedby="button-addon4"
                        class="form-control bg-none border-0"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <VueDatePicker
                            v-model="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            placeholder="Select Date Range"
                            class="form-control"
                            range
                            fullscreen-mobile
                            validate
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-primary" @click="generateExcel()" :disabled="!date">{{disable_button ? "Please Wait..." : "Export Excel" }}</button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="table-responsive datatable-vue">
                <b-table
                    striped hover
                    :items="savings.data"
                    :fields="fields"
                    :per-page="perPage"
                >
                  <template #cell(actions)="row" v-if="hasAccess">
                    <b-dropdown variant="transparent" class="m-md-2" no-caret>
                      <template #button-content>
                        <feather type="more-vertical"></feather>
                      </template>
                      <b-dropdown-item @click="mergeChama(row.item, row.index, $event.target)">Merge </b-dropdown-item>
                      <b-dropdown-item @click="updateMaturity(row.item, row.index, $event.target)">Update Maturity</b-dropdown-item>
                      <b-dropdown-item @click="matureSavings(row.item, row.index, $event.target)">Mature Savings</b-dropdown-item>
                      <b-dropdown-item @click="deleteChama(row.item, row.index, $event.target)">Delete</b-dropdown-item>
                    </b-dropdown>
                  </template>
                </b-table>
              </div>

              <b-col md="6" class="mt-3 p-0">
                <b-pagination v-if="savings.data && savings.data.length >= 1"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              @change="handlePageChange"
                              class="my-0"
                ></b-pagination>
                <div class="text-center" v-else>
                  No Records Found
                </div>
              </b-col>
            </div>
          </px-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getRequestParams} from "@/helpers/pagination";
import {saving_summary_fields} from "@/pages/savings/fields/saving_summary_field_defs";
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  components: {VueDatePicker},
  data() {
    return {
      fields: saving_summary_fields,
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 50, 100],
      searchTitle: "",
      date: "",
      currentDate: new Date(),
      date_from:'',
      date_to:'',
      disable_button:false,
      loading:false
    }
  },
  mounted() {
    this.retrieveSavings();
  },
  computed:{
    ...mapGetters({savings:'getSavingsSummary'}),
    minDate () {
      return new Date(
          this.currentDate.getFullYear() - 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    maxDate () {
      return new Date(
          this.currentDate.getFullYear() + 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate(),
      );
    },
    hasAccess(){
      var loginId = localStorage.getItem('login_id')
      if (!loginId) return false;
      const allowedIds = ['77', '1085', '1645','915'];

      return allowedIds.includes(loginId);
    },
  },
  watch: {
    savings() {
      this.totalRows = this.savings.meta.total;
      console.log('rows '+this.totalRows)
      console.log(this.savings.data.length)
    },
    searchTitle() {
      this.retrieveSavings();
    },
    date() {
      this.date_from  = this.date.start;
      this.date_to  = this.date.end;
      this.retrieveSavings();
    }
  },
  methods:{
    mergeChama(item, index, button) {
      this.$swal({
        title: 'Merge Chama',
        text: 'Enter chama account number to be merged to '+item.account_number,
        input: 'text',
        inputPlaceholder: 'Enter chama account number',
        showCancelButton: true,
        confirmButtonText: 'Merge',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#4466f2',
        cancelButtonColor: '#6c757d',
        preConfirm: (value) => {
          if (!value) {
            this.$swal({
              title: 'Error!',
              text: 'Please enter chama account number to be merged to '+item.account_number,
              icon: 'error'
            });
            return false;
          }

          return value;
        }
      }).then((result) => {
        if (result.value) {
          const accountNo = result.value;
          this.loading = true;
          this.disable_button = true;

          axios
              .post('/admin/merge-chama', {
                from_account_number:accountNo,
                to_account_number: item.account_number,
                user_id: item.user_id
              })
              .then((res) => {
                this.$swal({
                  title: 'Success!',
                  text: 'Chama successfully merged!',
                  icon: 'success'
                });
                setTimeout(() => {
                  this.$router.go();
                }, 1000);
              })
              .catch((err) => {
                this.$swal({
                  title: 'Error!',
                  text: 'An error occurred, chama could not be merged.',
                  icon: 'error'
                });
              })
              .finally(() => {
                this.loading = false;
                this.disable_button = false;
              });
        } else {
          this.$swal({
            text: 'Request cancelled.',
            icon: 'info'
          });
        }
      });
    },

    updateMaturity(item, index, button) {
      this.$swal({
        title: 'Update Maturity Date',
        html: `
      <div style="text-align:left">
        <label for="maturity-date" style="font-size:14px; font-weight:600;">Select new maturity date:</label>
        <input type="date" id="maturity-date" class="swal2-input" style="width:90%; margin-top:10px;" min="${new Date().toISOString().split('T')[0]}">
      </div>
    `,
        showCancelButton: true,
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#4466f2',
        cancelButtonColor: '#6c757d',
        preConfirm: () => {
          const maturityDate = document.getElementById('maturity-date').value;
          if (!maturityDate) {
            this.$swal({
              title: 'Error!',
              text: 'Please select a new maturity date',
              icon: 'error'
            });
            return false;
          }
          return maturityDate;
        }
      }).then((result) => {
        if (result.value) {
          const selectedDate = result.value;
          this.loading = true;
          this.disable_button = true;

          axios
              .post('/admin/update-maturity', {
                product_id: item.product_id,
                new_maturity_date: selectedDate,
                user_id: item.user_id
              })
              .then((res) => {
                this.$swal({
                  title: 'Success!',
                  text: 'Chama maturity date updated successfully!',
                  icon: 'success'
                });
                setTimeout(() => {
                  this.$router.go();
                }, 1000);
              })
              .catch((err) => {
                this.$swal({
                  title: 'Error!',
                  text: 'An error occurred. Chama maturity date could not be updated.',
                  icon: 'error'
                });
                console.error('Error updating maturity date:', err);
              })
              .finally(() => {
                this.loading = false;
                this.disable_button = false;
              });
        } else {
          this.$swal({
            text: 'Request cancelled.',
            icon: 'info'
          });
        }
      });
    },


    matureSavings(item, index, button) {
      this.$swal({
        text:'Are you sure you want mature this?',
        showCancelButton: true,
        confirmButtonText: 'Cancel!',
        confirmButtonColor: '#4466f2',
        cancelButtonText: 'Yes',
        cancelButtonColor: '#4466f2',
      }).then((result)=>{
        if(result.value){
          this.$swal({
            text:"Opps, Request Cancelled!"
          });
        }else{
          this.show_autorecover = false;
          this.loading= true;
          this.disable_button = true;
          axios.post('/admin/mature-savings',{product_id:item.product_id,'user_id':item.user_id})
              .then(res => {
                this.$swal({
                  title:"Success!",
                  text:"Chama Successfully Matured!",
                  type:'success'
                });
                setTimeout(()=>{
                  this.$router.go()
                },1000)


              }).catch(err => {
            this.$swal({
              text:"Oop! An Error occurred, chama could not be matured."
            });
            console.log('error occurred in sending sms')
            console.log(err)
          })

        }
      });

    },

    deleteChama(item, index, button) {
      this.$swal({
        text:'Are you sure you want to delete this?',
        showCancelButton: true,
        confirmButtonText: 'Cancel!',
        confirmButtonColor: '#4466f2',
        cancelButtonText: 'Yes',
        cancelButtonColor: '#4466f2',
      }).then((result)=>{
        if(result.value){
          this.$swal({
            text:"Opps, Request Cancelled!"
          });
        }else{
          this.show_autorecover = false;
          this.loading= true;
          this.disable_button = true;
          axios.post('/admin/delete-chama',{product_id:item.product_id,'user_id':item.user_id})
              .then(res => {
                this.$swal({
                  title:"Success!",
                  text:"Chama Successfully Deleted!",
                  type:'success'
                });
                setTimeout(()=>{
                  this.$router.go()
                },1000)


              }).catch(err => {
            this.$swal({
              text:"Oop! An Error occurred, chama could not be deleted."
            });
            console.log('error occurred in sending sms')
            console.log(err)
          })

        }
      });

    },
    retrieveSavings() {
      const params = getRequestParams(
          this.searchTitle,
          this.currentPage,
          this.perPage
      );
      this.$store.dispatch('updateSavingsSummary',params)
    },
    handlePageChange(value) {
      this.currentPage = value
      this.retrieveSavings();
    },
    generateExcel() {
      // Prepare the form data
      const formData = {
        date_from: this.date.start,
        date_to: this.date.end
      };

      // Show loading state (optional)
      this.loading = true;
      this.disable_button = true;
      // Make the request to the backend
      axios.post('savings/export-report', formData, { responseType: 'blob' })
          .then((response) => {
            this.$swal({
              title:"Good job!",
              text:"Export is being processed. It will be sent to your email shortly!",
              type:'info'
            }).then(() => {
              this.loading = false;
              this.disable_button = false;
            })
          })
          .catch((error) => {
            console.error('Error generating report:', error);
            alert('An error occurred while generating the report. Please check your inputs or try again later.');
          })
          .finally(() => {
            // Reset loading state (optional)
            this.loading = false;
            this.disable_button = false;
          });
    }
  }
}
</script>

<style scoped>
.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}

.card {
  box-shadow: 7px 7px 7px 7px rgba(50, 50, 50, 0.5) !important;
}
.card_green {
  color: #63D926 !important;
}
</style>
